export default __webpack_public_path__ + "static/brokered-by-exp-xolor-0c04c6d0ec94b8d13f297b63ef312a53.png";